import { c as _c } from "react/compiler-runtime";
import React from 'react';
interface ShareIconProps {
  size?: number;
  className?: string;
}
const ShareIcon = t0 => {
  const $ = _c(6);
  const {
    size: t1,
    className: t2
  } = t0;
  const size = t1 === undefined ? 24 : t1;
  const className = t2 === undefined ? "" : t2;
  const t3 = `dynamic-size ${className}`;
  let t4;
  if ($[0] !== size) {
    t4 = {
      "--width": size,
      "--height": size
    };
    $[0] = size;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = t4 as React.CSSProperties;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <path d="M17 22C16.1667 22 15.4583 21.7083 14.875 21.125C14.2917 20.5417 14 19.8333 14 19C14 18.9 14.025 18.6667 14.075 18.3L7.05 14.2C6.78333 14.45 6.475 14.646 6.125 14.788C5.775 14.93 5.4 15.0007 5 15C4.16667 15 3.45833 14.7083 2.875 14.125C2.29167 13.5417 2 12.8333 2 12C2 11.1667 2.29167 10.4583 2.875 9.875C3.45833 9.29167 4.16667 9 5 9C5.4 9 5.775 9.071 6.125 9.213C6.475 9.355 6.78333 9.55067 7.05 9.8L14.075 5.7C14.0417 5.58333 14.021 5.471 14.013 5.363C14.005 5.255 14.0007 5.134 14 5C14 4.16667 14.2917 3.45833 14.875 2.875C15.4583 2.29167 16.1667 2 17 2C17.8333 2 18.5417 2.29167 19.125 2.875C19.7083 3.45833 20 4.16667 20 5C20 5.83333 19.7083 6.54167 19.125 7.125C18.5417 7.70833 17.8333 8 17 8C16.6 8 16.225 7.929 15.875 7.787C15.525 7.645 15.2167 7.44933 14.95 7.2L7.925 11.3C7.95833 11.4167 7.97933 11.5293 7.988 11.638C7.99667 11.7467 8.00067 11.8673 8 12C7.99933 12.1327 7.99533 12.2537 7.988 12.363C7.98067 12.4723 7.95967 12.5847 7.925 12.7L14.95 16.8C15.2167 16.55 15.525 16.3543 15.875 16.213C16.225 16.0717 16.6 16.0007 17 16C17.8333 16 18.5417 16.2917 19.125 16.875C19.7083 17.4583 20 18.1667 20 19C20 19.8333 19.7083 20.5417 19.125 21.125C18.5417 21.7083 17.8333 22 17 22ZM17 20C17.2833 20 17.521 19.9043 17.713 19.713C17.905 19.5217 18.0007 19.284 18 19C17.9993 18.716 17.9033 18.4787 17.712 18.288C17.5207 18.0973 17.2833 18.0013 17 18C16.7167 17.9987 16.4793 18.0947 16.288 18.288C16.0967 18.4813 16.0007 18.7187 16 19C15.9993 19.2813 16.0953 19.519 16.288 19.713C16.4807 19.907 16.718 20.0027 17 20ZM5 13C5.28333 13 5.521 12.904 5.713 12.712C5.905 12.52 6.00067 12.2827 6 12C5.99933 11.7173 5.90333 11.48 5.712 11.288C5.52067 11.096 5.28333 11 5 11C4.71667 11 4.47933 11.096 4.288 11.288C4.09667 11.48 4.00067 11.7173 4 12C3.99933 12.2827 4.09533 12.5203 4.288 12.713C4.48067 12.9057 4.718 13.0013 5 13ZM17 6C17.2833 6 17.521 5.904 17.713 5.712C17.905 5.52 18.0007 5.28267 18 5C17.9993 4.71733 17.9033 4.48 17.712 4.288C17.5207 4.096 17.2833 4 17 4C16.7167 4 16.4793 4.096 16.288 4.288C16.0967 4.48 16.0007 4.71733 16 5C15.9993 5.28267 16.0953 5.52033 16.288 5.713C16.4807 5.90567 16.718 6.00133 17 6Z" fill="#2A2A31" />;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] !== t3 || $[4] !== t5) {
    t7 = <svg className={t3} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={t5}>{t6}</svg>;
    $[3] = t3;
    $[4] = t5;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  return t7;
};
export default ShareIcon;